import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Footer() {
  return (
    <footer>
      <Container>
        <Row>
          <Col style={{ textAlign: 'center' }}>
            Copyright &copy; Hero Dynamics
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
